import { IconProps } from './icon';

export const ChevronLeftIcon = (props: IconProps): JSX.Element => {
	const { size = 24, ...extraProps } = props;
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			{...extraProps}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M15 6l-6 6l6 6" />
		</svg>
	);
};
